<template>
  <div class="icon-wrap" v-if="show">
    <template v-if="success">
        <img src="../../assets/success.svg">
        <p>{{_('上报成功')}}</p>
    </template>
    <template v-else>
        <img src="../../assets/fail.svg">
        <p v-if="isFailed">{{_('身份认证失败,请重新扫码')}}</p>
        <p v-else>{{_('身份认证已过期,请重新扫码')}}</p>
    </template>
  </div>
</template>

<script>
import { getParams } from '../utils'
import {FAILED, FAILED1, FAILED2} from '../const';

export default {
    data () {
        return {
            show: false,
            success: false,
            code: ''
        };
    },
    mounted () {
        this.feedback();
    },
    computed :{
        isFailed () {
            return this.code === FAILED || this.code === FAILED1 || this.code === FAILED2;
        }
    },
    methods: {
        async feedback () {
            let rs = await this.axios.get(`/v1/sp-better/feedback/${getParams()}`);
            this.$emit('showView');
            this.show = true;
            this.code = rs.data.code;
            if (rs.data.code === 0) {
                this.success = true;
            }
            document.title = this._('上报升级反馈');
      }
    }
}
</script>

<style scoped>
.icon-wrap {
    padding: 45px 0 35px 0;
    text-align: center;
}
.icon-wrap > img {
    width: 88px;
    height: 88px;
}
</style>